import React from 'react'
import PropTypes from 'prop-types'
import { CRUDShow } from '../CRUD'

const ClasseConsumoShow = (props) => {
  if (props.classeConsumo) {
    return (
      <CRUDShow
        title={props.classeConsumo.nome}
        icon='block layout'
        onEditResource={() => props.onEditResource(props.classeConsumo.id)}
        onDeleteResource={() => props.onDeleteResource(props.classeConsumo.id)}>
        <ul>
          <li>Nome: {props.classeConsumo.nome}</li>
          <li>Descrição: {props.classeConsumo.descricao}</li>
        </ul>
      </CRUDShow>
    )
  }

  return (null)
}

ClasseConsumoShow.propTypes = {
  classeConsumo: PropTypes.object,
  onEditResource: PropTypes.func,
  onDeleteResource: PropTypes.func,
}

export default ClasseConsumoShow
